<template>
    <div>
        <div>
            <el-dialog title="选择视频" center :visible.sync="isShowDialog" v-if="isShowDialog" append-to-body width="90%"
                :before-close="beforeclose" :close-on-click-modal="false">
                <el-form :inline="true" ref="searchform" :model="formData" class="demo-form-inline" size="medium">
                    <el-form-item label="视频编号:" prop="videoId">
                        <el-input type="text" v-model="formData.videoId" placeholder="请输入视频编号,多个英文逗号隔开"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="视频标题:" prop="videoTitle">
                        <el-input type="text" v-model="formData.videoTitle" placeholder="请输入视频标题" clearable></el-input>
                    </el-form-item>

                    <el-form-item label="栏目:" prop="columnIdList">
                        <el-select multiple collapse-tags v-model="formData.columnIdList" placeholder="全部" clearable>
                            <el-option v-for="item in columnOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态:" prop="videoStatus">
                        <el-select v-model="formData.videoStatus" placeholder="请选择">
                            <el-option label="全部" :value="''"></el-option>
                            <el-option label="显示" :value='1'></el-option>
                            <el-option label="不显示" :value='0'></el-option>
                        </el-select>
                    </el-form-item>

                    <span style="margin-left: 20px">
                        <el-button type="primary" @click="search">查询</el-button>
                        <el-button plain type="info" @click="resetForm('searchform')">重置</el-button>
                    </span>
                </el-form>
                <div style="margin-top: 20px">
                    <!-- :selectable="selected"  控制禁选-->
                    <el-table v-loading="loading" :data="tableData" border style="width: 100%" @select="changeFun"
                        @selection-change="handleSelectionChange" ref="multipleTable" row-key="videoId">
                        <el-table-column type="selection" width="55" reserve-selection align="center"></el-table-column>

                        <el-table-column prop="videoId" label="视频编号" align="center"></el-table-column>
                        <el-table-column prop="coverImageUrl" label="封面" align="center">
                            <template slot-scope="scope">
                                <img style="width: 30px; height: 30px;" :src="scope.row.coverImageUrl" alt="">
                            </template>
                        </el-table-column>
                        <el-table-column prop="videoTitle" label="视频标题" align="center"></el-table-column>
                        <el-table-column prop="columnName" label="栏目名称" align="center"></el-table-column>
                        <el-table-column prop="viewCount" label="真实浏览量" align="center"></el-table-column>
                        <el-table-column prop="virtualViewCount" label="虚拟浏览量" align="center"></el-table-column>
                        <el-table-column prop="likeCount" label="真实点赞数" align="center"></el-table-column>
                        <el-table-column prop="virtualLikeCount" label="虚拟点赞数" align="center"></el-table-column>

                        <el-table-column prop="videoStatus" label="状态" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.videoStatus === 1">显示</span>
                                <span v-else-if="scope.row.videoStatus === 0">隐藏</span>
                            </template>
                        </el-table-column>

                        <el-table-column prop="updateBy" label="修改人" align="center"></el-table-column>
                        <el-table-column prop="updateTime" label="修改时间" align="center"></el-table-column>
                    </el-table>
                </div>
                <div class="coupon-clock-paging">
                    <div>已选视频数量：{{ selectionDataAll.length }}</div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="formData.pageIndex" :page-sizes="[10, 20, 30, 40, 50]" :page-size="formData.pageSize"
                        layout="total,sizes, prev, pager, next, jumper" :total="total" background></el-pagination>
                </div>
                <el-row type="flex" justify="center" style="margin-top: 100px">
                    <el-button @click="beforeclose">取消</el-button>
                    <el-button type="primary" @click="saveData">确定</el-button>
                </el-row>
            </el-dialog>
        </div>
    </div>
</template>
  
<script>
import { getHealthVideoList,getHealthColumnList } from "@/api/shop/healthManage";
export default {
    name: "videoListSelect",
    props: ["isShowDialog", "SelectedvideoList", 'limitNumber',],
    components: {

    },
    data() {
        return {
            columnOptions: [],
            formData: {
                platformCode: 'SHOP', // 平台
                videoId: '', //视频Id
                videoTitle: '',//视频名称
                videoStatus: '', //视频状态
                columnIdList: [], //分类id

                pageIndex: 1,
                pageSize: 10
            },
            loading: false,

            tableData: [], //表单数据
            total: 0, //总条数
            selectionData: [], //选中数据
            selectedIds: [],
            oldselectionData: [],
            activePage: 1
        };
    },
    created() {
        this.selectionData = []; //选中数据
        this.selectedIds = []
    },
    watch: {
        isShowDialog: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.getList()
                    this.getHealthColumnList()
                }
            },
            immediate: true,
            deep: true,
        },
        SelectedvideoList: {
            handler(newVal, oldVal) {
            },
            immediate: true,
            deep: true,
        },
        'formData.videoId': {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.formData.videoId = newVal.replaceAll('，', ',')
                }
            },
            immediate: false,
            deep: true,
        },
    },
    computed: {
        selectionDataAll() {
            let ids1 = this.oldselectionData.map(v => v.videoId)
            let ids2 = this.selectionData.map(v => v.videoId)
            let ids3 = [...new Set([...ids1, ...ids2])]
            return ids3
        }
    },
    methods: {
        getHealthColumnList() {
            let data = {
                platformCode: 'SHOP',
                columnStatus: 1
            }
            getHealthColumnList(data).then(res => {
                if (res.code = 200) {
                    this.columnOptions = res.data.rows.map(v => {
                        return {
                            key: v.columnId,
                            label: v.columnName,
                            value: v.columnId
                        }
                    })
                }
            })
        },
        getList() {
            let data = {
                ...JSON.parse(JSON.stringify(this.formData))
            }
            data.videoIdList = data.videoId ? data.videoId.split(',') : null
            delete data.videoId
            getHealthVideoList(data).then(res => {
                if (res.code == 200) {
                    this.total = res.data.count;
                    let arry = res.data.rows
                    this.tableData = arry
                    let arryAll = this.SelectedvideoList ? this.SelectedvideoList.map(v => v.videoId) : []
                    let selectedIds = this.selectedIds
                    if (this.SelectedvideoList) {
                        if (this.oldselectionData && this.oldselectionData.length > 0) {
                        } else if (this.oldselectionData.length == 0 || !this.oldselectionData) {
                            if (this.activePage == 1) {
                                this.oldselectionData = JSON.parse(JSON.stringify(this.SelectedvideoList))
                            }
                        }
                    }
                    for (let i in arry) {
                        if (arryAll.indexOf(arry[i].videoId) >= 0 && selectedIds.indexOf(arry[i].videoId) == -1) {
                            this.$refs.multipleTable.toggleRowSelection(arry[i]);
                            this.selectedIds.push(arry[i].videoId)
                            this.oldselectionData = this.oldselectionData.filter(v => v.videoId != arry[i].videoId)
                        }
                    }
                    this.activePage++
                }
            })
        },
        search() {
            this.formData.pageIndex = 1;
            this.getList();
        },
        resetForm(formName) {
            this.formData = {
                platformCode: 'SHOP', // 平台
                videoId: '', //视频Id
                videoTitle: '',//视频名称
                videoStatus: '', //视频状态
                columnIdList: [], //分类id

                pageIndex: 1,
                pageSize: 10
            }
            this.getList();
        },

        //修改每页数量
        handleSizeChange(val) {
            this.formData.pageSize = val;
            this.formData.pageIndex = 1;
            this.getList();
        },

        handleSelectionChange(val) {
            let ids1 = this.oldselectionData.map(v => v.videoId)
            let ids2 = val.map(v => v.videoId)
            let ids3 = [...new Set([...ids1, ...ids2])]
            if (this.limitNumber) {
                if (Number(ids3.length) > Number(this.limitNumber)) {
                    const del_row = val[val.length - 1]
                    this.$refs.multipleTable.toggleRowSelection(del_row, false)
                    this.$message.closeAll()
                    return this.$message.warning(`请选择小于${Number(this.limitNumber)}数量的数据`)
                }
            }
            this.selectionData = val;
        },

        changeFun(selection, row) { //限制选中数量
            // if (this.limitNumber) {
            //     if (selection.length > (this.limitNumber - Number(this.selectionData.length))) {
            //         const del_row = selection.shift()
            //         this.$refs.multipleTable.toggleRowSelection(del_row, false)
            //     }
            // }
        },


        selected(row, index) {
            if (this.selectedIds.indexOf(row.videoId) >= 0) {
                return false
            } else {
                return true
            }
        },
        saveData() {
            let ids1 = this.oldselectionData.map(v => {
                return {
                    ...v,
                    stock: v.oldstock ? v.oldstock : v.stock
                }
            })
            let ids2 = this.selectionData
            let ids3 = [...new Set([...ids1, ...ids2])]
            if (this.limitNumber) {
                if (ids3.length > this.limitNumber) {
                    return this.$message.warning(`请选择小于${this.limitNumber}条数据`)
                }
            }
            if (ids3.length > 0) {
                this.formData.status = ''; //视频状态(1:上架 2:下架)
                this.formData.videoId = '';  //视频Id
                this.formData.videoIdList = '';  //视频ID列表
                this.formData.videoTitle = ''; //视频名称
                this.formData.columnIdList = [];  //分类id
                this.formData.pageIndex = 1;  //当前页
                this.formData.pageSize = 10;  //页面数量
                this.$emit("selectvideoList", ids3);
                this.oldselectionData = [];
                this.activePage = 1;
                this.beforeclose()
            } else {
                this.$message.warning('请选择视频')
            }
        },
        //切换页面
        handleCurrentChange(val) {
            this.formData.pageIndex = val;
            this.getList();
        },

        beforeclose() {
            this.formData.status = ''; //视频状态(1:上架 2:下架)
            this.formData.videoId = '';  //视频Id
            this.formData.videoIdList = '';  //视频ID列表
            this.formData.productName = ''; //视频名称
            this.formData.columnIdList = [];  //分类id
            this.formData.prescriptionTypeList = []
            this.formData.pageIndex = 1;  //当前页
            this.formData.pageSize = 10;  //页面数量
            this.selectionData = []; //选中数据
            this.selectedIds = []
            this.oldselectionData = [];
            this.activePage = 1;
            this.$emit("closeShowDialog", false);
        },
        // changeFun(selection, row) {
        //     if (selection.length > 1) {
        //         const del_row = selection.shift()
        //         this.$refs.multipleTable.toggleRowSelection(del_row, false)
        //     }
        //     this.checkList = selection[0]
        // },
    },
};
</script>
  
<style scoped lang="less">
.product-sort-html {
    padding: 20px;
}

.coupon-clock-paging {
    width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/myviews/shoppMall/popularscienceManage/rdvideoManage/components/videoListSelect.vue